import React from "react";
import "./buttonTable.css";

const ButtonTable = ({ title }) => {
  const tableData = {
    headings: [
      "User Name",
      "Transaction ID",
      "Email",
      "Date",
      "Payment Method",
      "Receipt",
    ],
    data: [
      {
        userName: "Iftikhar Yousaf Khan",
        transactionID: "#1235666",
        email: "iftikharyousafkhan123@gmail.com",
        date: "29/10/2023, 12:30 AM",
        paymentMethod: "Card",
        receipt: "Download",
      },
    ],
  };

  for (let i = 0; i < 5; i++) {
    tableData.data.push(tableData.data[0]);
  }

  return (
    <div className="pvxButtonTable">
      <div className="title">
        <span>{title}</span>
        <div className="right">
          <div className="search-box">
            <img
              className="search-icon"
              src="../images/assets/search.png"
              alt="search icon"
            />
            <input
              className="input"
              type="text"
              placeholder="Search by User Name, Date"
            />
          </div>
          <img
            src="./images/PvxDashboard/Icons/Dots.svg"
            className="dots"
            alt="Dots"
          />
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            {tableData.headings.map((heading, index) => (
              <th key={index}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.data.map((row, index) => (
            <tr key={index}>
              <td>{row.userName}</td>
              <td>{row.transactionID}</td>
              <td>{row.email}</td>
              <td>{row.date}</td>
              <td>{row.paymentMethod}</td>
              <td>
                <span className="button">{row.receipt}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ButtonTable;
